import { useState } from "react";
import Tooltip from "./Tooltip";
import Botonera from "./botonera/Botonera";
import Titulo from "./Titulo";
import Parrafo from "./Parrafo";
import Traduccion from "./Traduccion";
import { useEffect } from "react";
import axios from "axios";




function Cuento({id})  {

    const [data, setData] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/cuentos/contenido/${id}`);
                setData(response.data);
            } catch (error) {
                console.error("Error fetching the story data", error);
            }
        };

        fetchData();
    }, [id]);


    
    
    

    const [tooltip, setTooltip] = useState({
        id: "",
        visible: false,
        content: "",
        top: 0,
        left: 0,
        width: 0,
    });

    const [verTraduccion, setVerTraduccion] = useState(true);
    const handleClickTraduccion = () => {
        setVerTraduccion(!verTraduccion);
        setTooltip({
            id: "",
            visible: false, 
            content: "",
            top: 0,
            left: 0
        });
    };

    const [verDesglose, setVerDesglose] = useState(true);
    const handleClickDesglose = () => {
        setVerDesglose(!verDesglose);
        setTooltip({
            id: "",
            visible: false, 
            content: "",
            top: 0,
            left: 0
        });
    };

    const [verFurigana, setVerFurigana] = useState(true);
    const handleClickFurigana = () => {
        setVerFurigana(!verFurigana);
        setTooltip({
            id: "",
            visible: false,
            content: "",
            top: 0,
            left: 0
        });
    };

    const [verRomaji, setVerRomaji] = useState(true);
    const handleClickRomaji = () => {
        setVerRomaji(!verRomaji);
        setTooltip({
            id: "",
            visible: false,
            content: "",
            top: 0,
            left: 0
        });
    };

    // Función para marcar/desmarcar todas las opciones
    const handleToggleAll = () => {
        // Si todas las opciones están activas, desactivar todas
        // Si al menos una está desactivada, activar todas
        const allActive = verDesglose && verTraduccion && verFurigana && verRomaji;
        
        if (allActive) {
            // Si todas están activas, desactivar todas
            setVerDesglose(false);
            setVerTraduccion(false);
            setVerFurigana(false);
            setVerRomaji(false);
        } else {
            // Si al menos una está desactivada, activar todas
            setVerDesglose(true);
            setVerTraduccion(true);
            setVerFurigana(true);
            setVerRomaji(true);
        }
        
        setTooltip({
            id: "",
            visible: false,
            content: "",
            top: 0,
            left: 0
        });
    };

    const [destacado, setDestacado] = useState(null);
    const [isClosingTooltip, setIsClosingTooltip] = useState(false);
    
    const handleCloseTooltip = () => {
        setIsClosingTooltip(true);
        setDestacado(null);
        setTooltip({
            id: "",
            visible: false,
            content: "",
            top: 0,
            left: 0
        });
        
        // Reset the flag after a short delay
        setTimeout(() => {
            setIsClosingTooltip(false);
        }, 200);
    };

    const handleClickSegmento = (event, content, idSegmento, isTitle=false) => {
        
        // Si estamos cerrando el tooltip, no hacer nada
        if (isClosingTooltip) {
            return;
        }
        
        // Si se hace click en la misma palabra que ya está abierta, cerrar el tooltip
        if (tooltip.id === idSegmento && tooltip.visible) {
            handleCloseTooltip();
            return;
        }
        
        // Si se hace click en una palabra diferente (o no hay tooltip abierto), mostrar el nuevo tooltip
        setDestacado(idSegmento);
        const rect = event.target.getBoundingClientRect();
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const top = rect.top + scrollTop - 100;

        const cuentoDiv = document.getElementById('cuento-div');
        const cuentoDivWidth = cuentoDiv ? cuentoDiv.offsetWidth  : 0;
        const cuentoDivCenter = cuentoDiv ? cuentoDiv.offsetWidth  : 0;

        setTooltip({
            id: idSegmento,
            visible: true, 
            content: content,
            top: top ,
            left: cuentoDivCenter, 
            width: cuentoDivWidth
        });
    };



  return (
    <div className="min-h-screen pt-[120px] pb-20 bg-gradient-to-br from-pearl-50 via-pearl-100 to-sage-50" id="cuento-container">
        <div className="mx-auto lg:w-3/5 w-4/5 relative">
            <Botonera
                onDesgloseClick={handleClickDesglose}
                onTraduccionClick={handleClickTraduccion}
                onFuriganaClick={handleClickFurigana}
                onClickRomaji={handleClickRomaji}
                onToggleAll={handleToggleAll}
                verDesglose={verDesglose}
                verTraduccion={verTraduccion}
                verFurigana={verFurigana}
                verRomaji={verRomaji}
            />
            
            {data && (
                <div  id="cuento-div" className="mt-10 px-4 py-2 lg:bg-pearl-50/80 lg:backdrop-blur-sm lg:rounded-3xl lg:shadow-2xl lg:border lg:border-sage-200/50 lg:p-12 mb-8">
                    <Titulo 
                        data={data.title}
                        ilustrador={data.ilustrador}
                        verTraduccion={verTraduccion}
                        verDesglose={verDesglose}
                        verFurigana={verFurigana}
                        verRomaji={verRomaji}
                        handleClickSegmento={handleClickSegmento}
                        destacado={destacado}
                    />
                    
                    {data && (
                        <div className="mt-8 space-y-6">
                            {data.paragraphs.map((paragraph, indexParagraph) => (
                                <div key={`paragraph_${indexParagraph}`} className="p-6 lg:p-6 bg-white/60 backdrop-blur-sm rounded-2xl border border-sage-100/50 shadow-lg hover:shadow-xl transition-all duration-300">
                                    <Parrafo
                                        data={paragraph}
                                        verTraduccion={verTraduccion}
                                        verDesglose={verDesglose}
                                        verFurigana={verFurigana}
                                        verRomaji={verRomaji}
                                        handleClickSegmento={handleClickSegmento}
                                        indice={indexParagraph}
                                        destacado={destacado}
                                    />
                                </div>
                            ))}
                        </div>
                    )}

                    {data && (
                        <div className="mt-8 space-y-6">
                            <div className="p-6 lg:p-6 bg-white/60 backdrop-blur-sm rounded-2xl border border-sage-100/50 shadow-lg hover:shadow-xl transition-all duration-300">
                                <Traduccion
                                    data={data.translation}
                                />
                            </div>
                        </div>
                    )}
                </div>
            )}

            {verDesglose && 
                <Tooltip
                    visible={tooltip.visible}
                    content={tooltip.content}
                    top={tooltip.top}
                    left={tooltip.left}
                    width={tooltip.width}
                    onClose={handleCloseTooltip}
                />            
            }
        </div>
    </div>
  );
}

export default Cuento;